(function () {
  'use strict';

  function initAnnouncementSlider() {
    document.querySelectorAll('.exode-announcement-bar__slider').forEach((slider) => {
      const slides = slider.querySelectorAll('.exode-announcement-bar__slide');
      if (slides.length < 2) return;

      const interval = parseInt(slider.dataset.interval, 10) || 5000;
      let index = 0;

      setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    });
  }

  function initMenuDrawer() {
    document.querySelectorAll('.exode-menu-drawer-container').forEach((drawer) => {
      drawer.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('exode-drawer-open', drawer.open);
        document.body.style.overflow = drawer.open ? 'hidden' : '';

        if (drawer.open) {
          requestAnimationFrame(() => drawer.classList.add('menu-opening'));
        } else {
          drawer.classList.remove('menu-opening');
          drawer.querySelectorAll('.exode-menu-drawer__submenu-details[open]').forEach((details) => {
            details.open = false;
          });
        }
      });

      drawer.querySelectorAll('[data-drawer-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('details');
          if (details) details.open = false;
        });
      });

      drawer.querySelectorAll('.exode-menu-drawer__submenu-details > summary').forEach((summary) => {
        summary.addEventListener('click', (event) => {
          const details = summary.parentElement;
          if (!details) return;

          drawer.querySelectorAll('.exode-menu-drawer__submenu-details').forEach((item) => {
            if (item !== details) item.open = false;
          });

          if (details.open) {
            event.preventDefault();
            details.open = false;
          }
        });
      });
    });
  }

  function initHeaderHeight() {
    const header = document.querySelector('.exode-header-wrapper');
    const headerGroup = document.querySelector('#header-group');
    if (!header) return;

    const setHeight = () => {
      const headerRect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--exode-header-height', `${header.offsetHeight}px`);
      document.documentElement.style.setProperty('--exode-header-bottom-position', `${headerRect.bottom}px`);
      if (headerGroup) {
        document.documentElement.style.setProperty('--exode-header-offset', `${headerGroup.offsetHeight}px`);
      }
    };

    setHeight();
    window.addEventListener('resize', setHeight);
    window.addEventListener('scroll', setHeight, { passive: true });
  }

  function init() {
    initAnnouncementSlider();
    initMenuDrawer();
    initHeaderHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
